export default __webpack_public_path__ + "locales/de/DeleteThirdPartyDialog.json?hash=04cf406576a0af18743aa23e123aaf0b";